export default (fecha) => {
  var fechaActual = new Date();
  var diffYears =
    parseInt(fechaActual.getFullYear()) - parseInt(fecha.getFullYear());

  var months = diffYears * 12;

  return months;
};
